import { ChangeDetectorRef, Component, DestroyRef, inject, Input } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { LayoutService } from '../../core/services/layout/layout';
import { CustomRoute } from '../../app.routes';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TermPipe } from '../../shared/pipes/term.pipe';
import { TermKey, TerminologyKey } from '../../core/models/terminology.interface';

export interface MenuSection {
  title: string;
  icon: string;
  paths: string[];
  key: TerminologyKey;
  expanded?: boolean;
}

@Component({
  selector: 'app-sidebar',
  imports: [
    MatIconModule,
    CommonModule,
    MatIcon,
    MatToolbarModule,
    MatSidenavModule,
    RouterLink,
    MatExpansionModule,
    RouterLinkActive,
    TermPipe,
  ],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar {
  private destroyRef = inject(DestroyRef);
  showMenu = true;
  routes: CustomRoute[] = [];
  @Input() isOpen = false;
  @Input() isMobile = false;
  constructor(
    private layoutService: LayoutService,
    private cdr: ChangeDetectorRef,
    // private termPipe: TermPipe
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);

    this.layoutService.navLinks$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((routes) => {
      this.routes = routes;
    });

    this.layoutService.isOpen$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((open) => (this.isOpen = open));

    this.layoutService.showMenu$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((show) => (this.showMenu = show));
  }

  ngOnChanges() {
    this.cdr.detectChanges();
  }

  get mainRoutes(): CustomRoute[] {
    return this.routes.filter((r) => r.data?.isModule && r.data?.menuText);
  }

  // resolveText(route: CustomRoute): string {
  //   return this.termPipe.transform(route.data?.key ?? null, route.data?.menuText ?? '');
  // }

  resolveIcon(route: CustomRoute): string {
    return route.data?.icon ?? 'chevron_right';
  }

  getRoute(path: string): CustomRoute | undefined {
    return this.mainRoutes.find((r) => r.path === path);
  }

  toggleSection(section: MenuSection) {
    section.expanded = !section.expanded;
  }

  standalonePaths: string[] = ['home'];

  sections: MenuSection[] = [
    {
      title: 'Perfil',
      icon: 'account_circle',
      paths: ['profile-list', 'groups', 'changelog-list'],
      expanded: false,
      key: TermKey.ProfileSingular,
    },
    {
      title: 'Acompañamiento',
      icon: 'support_agent',
      paths: [
        'serviceactivity-list',
        'assistanceservice-list',
        'sourcefounding-list',
        'assistance-list',
      ],
      expanded: false,
      key: TermKey.AccompanimentSingular,
    },
    {
      title: 'Organización',
      icon: 'account_tree',
      paths: ['employee-list', 'line-list', 'component-list', 'sector-list', 'expense-list'],
      expanded: false,
      key: TermKey.OrganizationSingular,
    },
    {
      title: 'Inventario',
      icon: 'inventory_2',
      paths: ['fixedasset-list', 'consumableasset-list', 'infraestructure-list'],
      expanded: false,
      key: TermKey.InventorySingular,
    },
    {
      title: 'Ubicación',
      icon: 'location_on',
      paths: ['location-list', 'lifeplan-list', 'territory-list', 'address-list'],
      expanded: false,
      key: TermKey.LocationSingular,
    },
  ];
}
